export const BASE_URL = "https://devapi.bykit.in/api/admin/";
